import jwtDecode from "jwt-decode";
import { createContext, useContext, useEffect, useState } from "react";
import { useGetSingleUserAuthDetailQuery } from "../../Store/API/Auth/AuthAPI";
import { use } from "react";

// 👇 Define your mapping of permissions
const permissionConfig = {
  isFinanceVisible: "finance_user",
  isSaleVisible: "sales_user",
  isSalesAdmin: "sales_admin",
  isOperationVisible: "operation_user",
  isPurchaseVisible: "audit_user",
  isPurchaseAdmin: "audit_admin",
  isInventoryVisible: "inventory_user",
  isInventoryAdmin: "inventory_admin",
  isExecutionUser: "execution_user",
  isExecutionAdmin: "execution_admin",
  isUserVisible: "user",
  isHRMSUserVisible: "hrms_user",
  isWFHDVisible: "wfhd_user",
  isCommunityVisible: "community_user",
  isSarcasmVisible: "sarcasm_user",
  isAdvancedPurchaseVisible: "advance_purchase_user",
  isReportVisible: "reports",
  isBoostingVisible: "boosting_user",
  isBoostingAdmin: "boosting_admin",
  isPantryVisible: "pantry_user",
  isPlanCreationVisible: "plan_creation",
  isVendorSaleVisible: "vendor_sales_user",
  isRecoveryVisible: "recovery_user",
  isRecoveryAdmin: "recovery_admin",
  isInfluencerVisible: "influencer_user",
};

const ApiContextData = createContext();

const APIContext = ({ children }) => {
  let decodedToken = {};
  let storedToken = null;

  try {
    storedToken = sessionStorage.getItem("token");
    decodedToken = jwtDecode(storedToken);
  } catch (error) {

  }

  const userID = decodedToken?.id || null;
  const userName = decodedToken?.name || null;
  const ContextDept = decodedToken?.dept_id || null;
  const RoleIDContext = decodedToken?.role_id || null;
  const JobType = decodedToken?.job_type || null;
  const RoleKeyName = decodedToken?.role_key_name || null;
  //
  const { data: userAuthData } = useGetSingleUserAuthDetailQuery(userID);
  const [contextData, setContextData] = useState([]);
  const [permissions, setPermissions] = useState({
    isFinanceVisible: false,
    isSaleVisible: false,
    isSalesAdmin: false,
    isOperationVisible: false,
    isPurchaseVisible: false,
    isPurchaseAdmin: false,
    isInventoryVisible: false,
    isInventoryAdmin: false,
    isExecutionUser: false,
    isExecutionAdmin: false,
    isUserVisible: false,
    isHRMSUserVisible: false,
    isWFHDVisible: false,
    isCommunityVisible: false,
    isSarcasmVisible: false,
    isAdvancedPurchaseVisible: false,
    isReportVisible: false,
    isBoostingVisible: false,
    isPantryVisible: false,
    isPlanCreationVisible: false,
    isVendorSaleVisible: false,
    isRecoveryVisible: false,
    isInfluencerVisible: false,
  });

  useEffect(() => {
    if (RoleKeyName === "super_admin") {
      // Set all to true if user is super_admin
      const allTruePermissions = Object.fromEntries(
        Object.keys(permissions).map((key) => [key, true])
      );
      setPermissions(allTruePermissions);
      return;
    } else if (userAuthData && userAuthData.view) {
      setContextData(userAuthData);
      const viewPermissions = userAuthData.view;

      const computedFlags = Object.fromEntries(
        Object.entries(permissionConfig).map(([key, role]) => [
          key,
          viewPermissions.includes(role),
        ])
      );
      setPermissions(computedFlags);
    }
  }, [userAuthData, RoleKeyName]);

  return (
    <ApiContextData.Provider
      value={{
        contextData,
        userID,
        ContextDept,
        RoleIDContext,
        JobType,
        userName,
        ...permissions, // Expose isFinanceVisible, isSaleVisible, etc.
      }}
    >
      {children}
    </ApiContextData.Provider>
  );
};

const useAPIGlobalContext = () => useContext(ApiContextData);

export { APIContext, ApiContextData, useAPIGlobalContext };
